"use client";

import dynamic from "next/dynamic";
import { twMerge } from "tailwind-merge";

import HeroSection from "@/components/common/HeroSection";
import SectionHeader from "@/components/common/SectionHeader";

import { cardData, points } from "@/constants/SoftwareInt";
import { ImageCardData } from "@/constants/UIUXData";

import { useIsDark } from "@/context/ThemeContext";

const MiniCard = dynamic(() => import("@/components/common/MiniCard"));
const CheckMarks = dynamic(() => import("@/components/common/CheckMarks"));
const StatsCardsContainer = dynamic(() => import("@/components/StatCard"));
const ImageCard = dynamic(() => import("@/components/common/ImageCard"));

export default function SoftwareIntegration() {
  const isdark = useIsDark();

  return (
    <div className="relative flex flex-col justify-center items-center mt-6 z-10">
      <section className="mx-5 md:mx-[40px] xl:mx-[100px] 3xl:mx-[150]">
        <HeroSection
          heading="System Integrations"
          subHeading="Let's Build What's Next"
          paragraph="We specialize in delivering precise, high-quality digital solutions tailored to your unique business needs. Our comprehensive suite of services is thoughtfully structured-from initial concept and design to advanced cloud and AI-driven applications"
          headingStyles="text-[35px] mobile:text-[50px] sm:text-[60px] md:text-[75px] tablet:text-[95px] lg:text-[105px] xl:text-[135px] laptop:text-[155px] 3xl:text-[190px] 4xl:text-[210px] leading-[100%] text-center"
        />
      </section>

      <section className="flex flex-col items-center mx-5 md:mx-[40px] xl:mx-[100px] 3xl:mx-[150]">
        <SectionHeader
          title={"SERVICES WE PROVIDE in Software Integration"}
          wrapperClassName="xl:mt-[133px] laptop:mt-0 xl:mb-0 px-0"
        />
        <div className="hidden sm:grid grid-cols-3 w-full max-w-[2000px] gap-3 md:gap-5 xl:gap-22 laptop:gap-[161px] xl:mt-[50px] 3xl:mt-[70px]">
          {cardData.map((item, index) => (
            <MiniCard
              key={index}
              icon={item.icon}
              heading={item.heading}
              paragraph={item.paragraph}
              // cardStyles="w-[306px] h-[393px]"
            />
          ))}
        </div>
        <div className="flex sm:hidden flex-row flex-wrap justify-around w-full gap-3 mt-[50px] ">
          {cardData.map((item, index) => (
            <MiniCard
              key={index}
              icon={item.icon}
              heading={item.heading}
              paragraph={item.paragraph}
              paragraphStyles="leading-[28px] tracking-[0.02em] h-full"
              cardStyles="             
            w-full  
            mobile:w-[200px]
            mobile2:w-[264px]   
            "
            />
          ))}
        </div>
      </section>

      <section
        className={twMerge(
          "flex flex-col items-center w-full py-[25px] xl:py-[50px] px-5 md:px-[40px] xl:px-[100px] mt-10 3xl:mt-15",
          isdark ? "bg-[#2D2D2D]/50" : "bg-[#F2E4FE]/50"
        )}
      >
        <div className="w-full max-w-[2000px]">
          <SectionHeader
            title={"Why Choose software integration Solutions?"}
            description={"Transform your business with proven cloud advantages"}
            wrapperClassName="mt-0 md:mt-0 xl:mt-0 mb-0 md:mb-0 xl:mb-0"
            descriptionClassName="xl:mt-[50px]"
          />
          <div className="flex flex-col md:flex-row justify-between items-center mt-[25px] xl:mt-[70px]">
            <CheckMarks points={points} />
            <StatsCardsContainer gridStyles="p-2" cardStyles="md:w-[150px]" />
          </div>
        </div>
      </section>

      {/* <SectionHeader
        title={"latest projects"}
        description="A collection of latest data and AI works focused on enhancing user experiences and crafting modern digital interfaces."
        wrapperClassName="mt-[50px] mb-0 md:mb-0 xl:mb-0"
      /> */}

      {/* <div className="w-full px-5 md:px-10 xl:px-[100px]"> */}
      {/* Card slider for small screens */}
      {/* <div className="flex w-full mobile:hidden gap-4 overflow-x-auto snap-x snap-mandatory no-scrollbar">
          {ImageCardData.map((item, index) => (
            <div
              key={index}
              className="shrink-0 basis-[80%] small:basis-[65%]"
            >
              <ImageCard
                image={item.image}
                topic={item.topic}
                text={item.text}
                sizes="(max-width: 480px) 80vw, 65vw"
              />
            </div>
          ))}
        </div> */}

      {/* <div className="hidden mobile:grid mobile:grid-cols-2 tablet:grid-cols-3 w-full max-w-[2000px] gap-x-6 2xl:gap-x-8 3xl:gap-x-10 4xl:gap-x-12 gap-y-2 mt-[30px] xl:mt-[70px] mx-auto">
          {ImageCardData.map((item, index) => (
            <ImageCard
              key={index}
              image={item.image}
              topic={item.topic}
              text={item.text}
              frameworkButton={true}
              sizes="(max-width: 768px) 50vw, 33vw"
              frameworks={item.frameworks}
            />
          ))}
        </div>
      </div> */}

      <section className="mx-5 md:mx-10 xl:mx-[100px] 3xl:mx-[150]">
        <SectionHeader
          title={"READY TO ELEVATE YOUR DIGITAL PRESENCE ?"}
          description={
            "Each of our services is designed with precision, innovation, and excellence in mind, ensuring you receive solutions that truly add value to your business. Reach out to discuss your project and experience firsthand why leading businesses trust us to deliver exceptional results"
          }
          wrapperClassName="xl:mt-25 mb-[50px] px-0"
          descriptionClassName="xl:mt-[50px]"
        />
      </section>
    </div>
  );
}
